import '../../css/mk-brand.css';
import {useEffect, useState} from "react";
import GameClient from "../../lib/game-client";
import {useWallet} from "@solana/wallet-adapter-react";
import SuperOgPanels from "../../constants/super-og-panels";
import SuperOgGameStates from "../../constants/super-og-game-states";

function SuperOGGameLobby({onChangePanel, challenges, myGames, loading}) {
    useEffect(() => {}, );
    const [isShowingMyGames, setIsShowingMyGames] = useState(false);
    const wallet = useWallet();
    const onGetAccountInfo = async () => {
        try {
            if (wallet && wallet.connected) {
                return wallet;
            }
        } catch (error) {
            let message = error.msg || 'Could not access your wallet. Please try again.';
            if (!error.msg) {
                if (error.message.indexOf('0x138')) {
                } else if (error.message.indexOf('0x137')) {
                    message = `SOLD OUT!`;
                } else if (error.message.indexOf('0x135')) {
                    message = `Insufficient funds to mint. Please fund your wallet.`;
                }
            }
        } finally {
        }
    };
    if (!challenges) {return null;}
    return (
        <div id="super-og-lobby" className="ml-2">
            <div className="container bg-zinc-800 pt-4 px-2 md:px-32 pb-4 rounded-lg lg:max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div>
                                <div className="flex">
                                    <span className="text-5xl md:text-6xl lg:text-5xl font-bold text-brand">
                                      Super<span className="text-brand-text">OG </span>
                                    </span>
                                </div>
                                <div className="text-brand-text text-2xl pull-right cursor-pointer hover:font-bold">
                                    Game Lobby
                                </div>
                                <button className="text-brand-text font-bold bg-brand rounded-lg p-2 m-1"
                                        onClick={async () => {
                                            await onChangePanel(SuperOgPanels.Welcome);
                                        }}>Back to Instructions
                                </button>
                                <div className="border border-brand" />
                            </div>
                        </div>
                        <div className="container p-4">From here you can, browse and <b>accept</b> another player's '<b>Open Challenge</b>', view '<b>My Games</b>', or create a '<b>Challenge</b>' of your own.</div>
                        <div className="flex space-x-1">
                            <div className="bg-zinc-400 p-2 rounded-lg flex-col space-y-4">
                                <div className="flex justify-center space-x-2 text-sm md:text-2xl">
                                    <div
                                        className={`rounded-lg hover:bg-brand-hover ${isShowingMyGames ? 'bg-zinc-500' : 'bg-brand-hover' } p-4 cursor-pointer text-center font-bold`}
                                        onClick={()=>{setIsShowingMyGames(false);}}
                                    >Open Challenges</div>
                                    <div
                                        className={`text-center rounded-lg hover:bg-brand-hover ${isShowingMyGames ? 'bg-brand-hover' : 'bg-zinc-500'} p-4 cursor-pointer font-bold`}
                                        onClick={ async ()=>{
                                            setIsShowingMyGames(true);
                                        }}
                                    >My Games</div>
                                    <button
                                        className="bg-brand rounded-lg p-4 text-brand-text font-bold"
                                        onClick={async () => {
                                            loading(true);
                                            const info = await onGetAccountInfo();
                                            const responseData = await GameClient.createBlankSuperOGChallengeGame(info?.publicKey?.toString());
                                            onChangePanel(SuperOgPanels.NewChallenge, {game: responseData.data});
                                            loading(false);
                                        }}
                                    >Challenge</button>
                                </div>
                                <div className="p-1 h-96 overflow-y-scroll">
                                    <div className="" />
                                    {
                                        isShowingMyGames ?
                                            myGames?.map(game => {
                                            let gameStateMsg = 'unknown';
                                            let isWinner = game?.payoutWalletPK == wallet?.publicKey.toString();
                                            switch (game?.state) {
                                                case SuperOgGameStates.champPaymentFailed:
                                                    gameStateMsg = 'Payment Failed';
                                                    break;
                                                case SuperOgGameStates.open:
                                                    gameStateMsg = 'Cancel';
                                                    break;
                                                case SuperOgGameStates.cancelled:
                                                    gameStateMsg = 'Cancelled';
                                                    break;
                                                case SuperOgGameStates.completed:
                                                    gameStateMsg = isWinner ? 'Won' : 'Lost';
                                                    break;
                                                case SuperOgGameStates.error:
                                                    gameStateMsg = 'Error Occurred';
                                                    break;
                                                case SuperOgGameStates.start:
                                                    gameStateMsg = 'abandoned';
                                                    break;
                                                default:
                                                    // do nothing... just use the default
                                                    break;
                                            }
                                            let dynamicButtonClasses = game.state === SuperOgGameStates.open ? 'bg-brand cursor-pointer' : 'border';
                                            if (game.state === SuperOgGameStates.completed) {
                                                if (isWinner) {
                                                    dynamicButtonClasses = 'bg-winner cursor-pointer';
                                                } else {
                                                    dynamicButtonClasses = 'border cursor-pointer';
                                                }
                                            }
                                            return <div className="container flex border justify-between text-lg hover:bg-brand-hover" key={game.id}>
                                                <div className="m-2">{game.handle}</div>
                                                <div className="flex space-x-2 pull-right">
                                                    <div
                                                        className={`mt-1 my-auto p-1 font-bold ${dynamicButtonClasses} rounded-lg text-center`}
                                                        value={game.id}
                                                        onClick={async (e) => {
                                                            if (game.state > SuperOgGameStates.open) {
                                                                onChangePanel(SuperOgPanels.ShowReel, {game: game});
                                                            } else if (game.state === SuperOgGameStates.open) {
                                                                if (window.confirm('Are you sure you want to proceed?\n\nSelect OK to delete this challenge?')) {
                                                                    loading(true);
                                                                    const result = await GameClient.cancelGame(game, wallet.publicKey);
                                                                    if (!result || result?.data.success === false) {alert("Cancel failed.");}
                                                                    loading(false);
                                                                    onChangePanel(SuperOgPanels.Lobby, {});
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {gameStateMsg}
                                                    </div>
                                                    <div
                                                        className="fa fa-link my-auto p-1 rounded-lg cursor-pointer bg-zinc-400 hover:bg-brand-hover"
                                                        onClick={ async () => {
                                                            const link = GameClient.getChallengeLink(game);
                                                            await navigator.clipboard.writeText(`${link}`);
                                                            window.alert(`A link to the selected challenge has been copied to the clipboard. You can paste it to an opponent in a message or an email.\n\n${link}`);
                                                        }
                                                        }
                                                    />
                                                    <div className="mt-1 my-auto p-1 rounded-lg">{game.amount} {game.isSOL ? '$SOL' : '$CHEF'}</div>
                                                </div>
                                            </div>;
                                        })
                                            :
                                            challenges?.map(challenge => {
                                                return <div
                                                    key={challenge.id}
                                                    className="text-2xl h-16 cursor-pointer hover:bg-brand-hover"
                                                    value={challenge.id}
                                                    onClick={(e) => {
                                                        onChangePanel(SuperOgPanels.AcceptChallenge, {game: challenge});
                                                    }}
                                                >
                                                    <span className="mr-16">{challenge.handle}</span>
                                                    <span className="mt-1 text-xs p-1 bg-brand rounded-lg pull-right">{challenge.amount} {challenge.isSOL ? '$SOL' : '$CHEF'}</span>
                                                    <div className="border border-brand" />
                                                </div>;
                                            })
                                    }
                                </div>
                                <p>Click on a challenge to accept.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SuperOGGameLobby;